(function () {
  "use strict";

  if (customElements.get("product-additional-images")) return;

  class ProductAdditionalImages extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.images = [];
      this.currentIndex = 0;
      this.modal = null;
      this.bodyClass = "product-additional-images-modal-opened";

      this.touchStartX = 0;
      this.touchStartY = 0;
      this.initialPinchDistance = 0;
      this.currentScale = 1;
      this.isPinching = false;

      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(
        this.querySelectorAll(".product-additional-images__item")
      );

      this.images = this.items.map((item) => ({
        src: item.dataset.fullSrc,
        alt: item.dataset.alt || this.dataset.productTitle || ""
      }));

      this.items.forEach((item, index) => {
        item.addEventListener("click", () => this.open(index));
      });
    }

    open(index) {
      if (!this.images.length) return;

      this.currentIndex = index;
      this.buildModal();
      this.updateModalImage();

      document.body.classList.add(this.bodyClass);
      document.addEventListener("keydown", this.handleKeydown);
    }

    buildModal() {
      this.close();

      this.modal = document.createElement("div");
      this.modal.className = "product-additional-images-modal";

      this.modal.innerHTML = `
        <div class="product-additional-images-modal__content" role="dialog" aria-modal="true">
          <div class="product-additional-images-modal__counter"></div>

          <button type="button" class="product-additional-images-modal__close" aria-label="Close">
            <span>×</span>
          </button>

          <button type="button" class="product-additional-images-modal__nav product-additional-images-modal__nav--prev" aria-label="Previous image">
            <span class="product-additional-images-modal__nav-icon">‹</span>
          </button>

          <div class="product-additional-images-modal__viewport">
            <img class="product-additional-images-modal__img" alt="">
          </div>

          <button type="button" class="product-additional-images-modal__nav product-additional-images-modal__nav--next" aria-label="Next image">
            <span class="product-additional-images-modal__nav-icon">›</span>
          </button>
        </div>
      `;

      const viewport = this.modal.querySelector(".product-additional-images-modal__viewport");
      const img = this.modal.querySelector(".product-additional-images-modal__img");
      const closeBtn = this.modal.querySelector(".product-additional-images-modal__close");
      const prevBtn = this.modal.querySelector(".product-additional-images-modal__nav--prev");
      const nextBtn = this.modal.querySelector(".product-additional-images-modal__nav--next");

      this.modal.addEventListener("click", (event) => {
        if (event.target === this.modal) this.close();
      });

      closeBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        this.close();
      });

      prevBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        this.navigate(-1);
      });

      nextBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        this.navigate(1);
      });

      img.addEventListener("click", (event) => {
        event.stopPropagation();
        this.toggleZoom();
      });

      viewport.addEventListener(
        "touchstart",
        (event) => {
          if (event.touches.length === 1) {
            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
            this.isPinching = false;
          }

          if (event.touches.length === 2) {
            this.isPinching = true;
            this.initialPinchDistance = this.getPinchDistance(event.touches);
          }
        },
        { passive: true }
      );

      viewport.addEventListener(
        "touchmove",
        (event) => {
          if (event.touches.length === 2) {
            event.preventDefault();

            const distance = this.getPinchDistance(event.touches);
            const scale = distance / this.initialPinchDistance;

            this.currentScale = Math.min(Math.max(scale, 1), 3);
            img.style.transform = `scale(${this.currentScale})`;
            img.classList.toggle("is-zoomed", this.currentScale > 1.05);
          }
        },
        { passive: false }
      );

      viewport.addEventListener(
        "touchend",
        (event) => {
          if (this.isPinching) {
            this.isPinching = false;
            return;
          }

          if (this.currentScale > 1.05) return;

          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - this.touchStartX;
          const deltaY = touch.clientY - this.touchStartY;

          if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX < 0) {
              this.navigate(1);
            } else {
              this.navigate(-1);
            }
          }
        },
        { passive: true }
      );

      if (this.images.length <= 1) {
        prevBtn.style.display = "none";
        nextBtn.style.display = "none";
      }

      document.body.appendChild(this.modal);
    }

    updateModalImage() {
      if (!this.modal || !this.images[this.currentIndex]) return;

      const image = this.images[this.currentIndex];
      const img = this.modal.querySelector(".product-additional-images-modal__img");
      const counter = this.modal.querySelector(".product-additional-images-modal__counter");
      const viewport = this.modal.querySelector(".product-additional-images-modal__viewport");

      this.currentScale = 1;

      img.classList.remove("is-zoomed");
      img.style.transform = "scale(1)";

      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;

      img.src = image.src;
      img.alt = image.alt;

      counter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
    }

    navigate(direction) {
      if (this.images.length <= 1) return;

      this.currentIndex =
        (this.currentIndex + direction + this.images.length) % this.images.length;

      this.updateModalImage();
    }

    toggleZoom() {
      if (!this.modal) return;

      const img = this.modal.querySelector(".product-additional-images-modal__img");
      const viewport = this.modal.querySelector(".product-additional-images-modal__viewport");

      if (img.classList.contains("is-zoomed")) {
        this.currentScale = 1;
        img.classList.remove("is-zoomed");
        img.style.transform = "scale(1)";
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
      } else {
        this.currentScale = 1.8;
        img.classList.add("is-zoomed");
        img.style.transform = "scale(1.8)";
      }
    }

    getPinchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    handleKeydown(event) {
      if (event.key === "Escape") this.close();
      if (event.key === "ArrowLeft") this.navigate(-1);
      if (event.key === "ArrowRight") this.navigate(1);
    }

    close() {
      if (this.modal) {
        this.modal.remove();
        this.modal = null;
      }

      document.body.classList.remove(this.bodyClass);
      document.removeEventListener("keydown", this.handleKeydown);
    }
  }

  customElements.define("product-additional-images", ProductAdditionalImages);
})();